/* eslint-disable react/no-did-update-set-state */
import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { QueryFirstChildFromRef } from 'Helpers/Dom';
import { noop } from 'Helpers/PropTypes';
import VerticalExpander from './VerticalExpander';
import './LabeledVerticalExpander.css';
import FontAwesome from '../FontAwesome/FontAwesome';

class LabeledVerticalExpander extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.firstChildRef = React.createRef();
    this.scrollTarget = React.createRef();

    const { expanded } = props;
    this.content = createRef();

    this.state = { expanded, wasExpanded: false, height: 'auto' };

    this.onFocus = this.onFocus.bind(this);
    this.focusFirstTabbable = this.focusFirstTabbable.bind(this);
  }

  // TODO: Refactor this to not need setInterval
  componentDidMount() {
    setTimeout(() => {
      const { expanded } = this.state;
      if (expanded) {
        this.focusFirstTabbable();
      }
    }, 100);
  }

  componentDidUpdate() {
    const { expanded, wasExpanded } = this.state;
    const { expanded: expandedProp } = this.props;
    const tabbedToUnexpanded = expanded && !wasExpanded;
    const clickedContinueToUnexpanded = expandedProp && !wasExpanded;
    if (tabbedToUnexpanded || clickedContinueToUnexpanded) {
      this.focusFirstTabbable();
      this.setState({ wasExpanded: true });
    }
  }

  onToggle() {
    const { expanded } = this.state;
    const { collapseSection, expandedIndex } = this.props;

    this.setState(
      {
        expanded: !expanded,
        wasExpanded: expanded,
      },
      () => {
        if (expanded) {
          collapseSection(expandedIndex);
        }
      },
    );
  }

  onFocus() {
    const { expanded } = this.state;
    if (!expanded) {
      this.onToggle();
    }
  }

  getClassNames() {
    const { expanded } = this.state;
    return classnames({
      'labeled-vertical-expander': true,
      expanded,
      collapsed: !expanded,
    });
  }

  focusFirstTabbable() {
    const firstInput = QueryFirstChildFromRef(this.firstChildRef);
    if (firstInput) {
      firstInput.focus();
    }
  }

  childrenWithRef() {
    const { children, firstElementFocusable } = this.props;
    if (!firstElementFocusable) {
      return children;
    }
    let setFocusRef = false;
    return React.Children.map(children, (child) => {
      if (setFocusRef) {
        return child;
      }
      setFocusRef = true;
      return React.cloneElement(child, {
        ref: this.firstChildRef,
      });
    });
  }

  render() {
    const {
      state: { expanded },
      props: {
        transitionSpeed,
        title,
        titleRight,
        titleLeft,
        test,
        CountComponent,
        additionalActions,
        subTitle,
        TitleComponent,
      },
    } = this;

    let {
      state: { height },
    } = this;

    let className = 'vertical-expander-label';

    if (expanded) {
      className += ' expanded';
    } else {
      height = 0;
      className += ' collapsed';
    }

    let testLabel = 'label';
    if (typeof title === 'string') {
      testLabel = title + testLabel;
    } else if (test && test.length > 0) {
      testLabel += test;
    }
    return (
      <div
        className={this.getClassNames()}
        ref={(ref) => {
          this.scrollTarget = ref;
        }}
      >
        <div
          className={className}
          role="presentation"
          test={testLabel}
          onClick={() => this.onToggle()}
        >
          <div style={{ width: '50%' }}>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              {TitleComponent}
              {title}
            </div>
            {!!titleLeft && (
              <span className="title-left">
                {titleLeft}
              </span>
            )}
            {subTitle}
          </div>
          {typeof CountComponent === 'object' && CountComponent}
          {typeof CountComponent === 'function' && <CountComponent />}
          <div className="heading-right">
            {additionalActions.map((el, i) => (
              <div
                style={{ paddingRight: 16 }}
                key={i} // eslint-disable-line react/no-array-index-key
              >
                {el}
              </div>
            ))}
            {titleRight !== '' && (
              <span className="title-right">{titleRight}</span>
            )}
            <span className="expand-button">
              <FontAwesome icon={expanded ? 'minus-circle' : 'plus-circle'} />
            </span>
          </div>
        </div>
        <VerticalExpander
          expanded={expanded}
          height={height}
          transitionSpeed={transitionSpeed}
        >
          <div
            ref={this.content}
            className="content"
            onFocus={() => this.onFocus()}
          >
            {this.childrenWithRef()}
          </div>
        </VerticalExpander>
      </div>
    );
  }
}

LabeledVerticalExpander.propTypes = {
  transitionSpeed: PropTypes.number,
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
  title: PropTypes.node,
  titleRight: PropTypes.node,
  titleLeft: PropTypes.node,
  firstElementFocusable: PropTypes.bool,
  collapseSection: PropTypes.func,
  expandedIndex: PropTypes.number,
  test: PropTypes.string,
  CountComponent: PropTypes.any,
  additionalActions: PropTypes.array,
  subTitle: PropTypes.object,
  TitleComponent: PropTypes.object,
};

LabeledVerticalExpander.defaultProps = {
  transitionSpeed: 1,
  expanded: false,
  title: '',
  titleRight: '',
  titleLeft: undefined,
  firstElementFocusable: false,
  collapseSection: noop,
  expandedIndex: 0,
  test: '',
  CountComponent: undefined,
  additionalActions: [],
  subTitle: null,
  TitleComponent: null,
};

export default LabeledVerticalExpander;
